import React, { useRef, useEffect, useCallback, useState} from 'react';
import {WIDTH, HEIGHT, PADDING} from './constants.js';
import {connect} from 'react-redux';

const Forces = ({
    onClick,
    onMouseMove,
    onMouseUp,
    onMouseDown,
    forcePaths,
    effect,
    forces,
    drawForces
}) => { 
    let ref = useRef(undefined);
    let ctxt = useRef(undefined);

    useEffect(() => {
        ctxt.current = ref.current.getContext('2d');
        ctxt.current.scale(window.devicePixelRatio, window.devicePixelRatio);
    }, []);

    useEffect(() => {
        if (!ctxt.current ){
            return;
        }
        window.requestAnimationFrame(draw);
    }, [forces]);

    const draw = useCallback(() => {
        ctxt.current.clearRect(0,0,WIDTH,HEIGHT);
        forcePaths.current = drawForces(ctxt.current);
    }, []);

    let style = {
        height: HEIGHT,
        width: WIDTH
    };
    return (
        <canvas
          style={style}
          onClick={onClick}
          onMouseMove={onMouseMove}
          onMouseUp={onMouseUp}
          onMouseDown={onMouseDown}
          ref={ref}
          width={window.devicePixelRatio*WIDTH} height={window.devicePixelRatio*HEIGHT}
          className="force-drawer"
        >
        </canvas>
    );
};

const mapStateToProps = (state, props) => {
    let groups = props.effect.groups;
    let s = '';
    for (let group of groups) {
        for (let vary of group.variables) {
            s += vary.name + ',' + vary.get();
        }
    }
    return {forces: s};
};
export default connect(mapStateToProps, null)(Forces);
